<mat-chip-set>
    @for (item of items(); track item) {
        <mat-chip
            #chipTooltip="matTooltip"
            removable
            [matTooltip]="getItemLabel(item)"
            [class.st-check-list-chip-max-width-long]="asCustomField() && internalValue()?.length === maxItemsToShow()"
            [class.st-check-list-chip-max-width-short]="asCustomField() && internalValue()?.length > maxItemsToShow()"
            [class.st-check-list-chip-max-width]="asCustomField()"
            [disabled]="disabled()"
            (removed)="onRemove(item)">
            {{ getItemLabel(item) }}
            <button
                tabIndex="0"
                matChipRemove
                [attr.aria-label]="'remove ' + item"
                [disabled]="disabled()">
                <mat-icon>close</mat-icon>
            </button>
        </mat-chip>
    }
    @if (shouldShowMoreTooltip()) {
        <mat-chip
            #tooltip="matTooltip"
            tabIndex="0"
            [matTooltip]="itemsAsTooltip()"
            [matMenuTriggerFor]="listDropDownMenu"
            [disabled]="disabled()"
            (menuOpened)="onMenuOpened()">
            {{ showMoreTooltip() }}
        </mat-chip>
    }
    <button
        mat-button
        class="st-check-list-button"
        [class.st-check-list-button-valid]="(required() && internalValue() && internalValue()?.length === 0) || !internalValue()"
        [class.st-check-list-button-required]="required()"
        [matMenuTriggerFor]="listDropDownMenu"
        [disabled]="disabled()"
        (menuOpened)="onMenuOpened()"
        (menuClosed)="onValueChanged()">
        <span
            [class.st-check-list-button-label]="asCustomField()"
            [class.st-check-list-button-label-long]="asCustomField() && internalValue()?.length === maxItemsToShow()"
            [class.st-check-list-button-label-short]="asCustomField() && internalValue()?.length > maxItemsToShow()"
            >{{ label() || placeholder() }}</span
        >
        <mat-icon>add</mat-icon>
    </button>
</mat-chip-set>

<mat-menu
    #listDropDownMenu="matMenu"
    class="st-check-list-menu">
    <form
        st-click-stop-propagation
        class="st-check-list-form"
        [dir]="dir">
        <mat-form-field
            subscriptSizing="dynamic"
            appearance="fill">
            <mat-icon matPrefix>search</mat-icon>
            <input
                #searchBox
                type="text"
                matInput
                [placeholder]="searchLabel()"
                [formControl]="checkListFilter"
                (keydown.arrowup)="onUpArrowPress()"
                (keydown.arrowdown)="onDownArrowPress()" />
        </mat-form-field>
        <mat-selection-list
            class="st-check-list-form-options"
            st-click-stop-propagation
            [ngModel]="internalValue()"
            (selectionChange)="onSelectionChange($event)">
            <mat-list-option
                *ngFor="let item of filteredOptions | async"
                [disabled]="!item.selectable"
                [value]="item?.id">
                {{ getItemLabel(item?.id) }}
            </mat-list-option>
        </mat-selection-list>
    </form>
</mat-menu>
